// Keep in sync with netlify/functions/lib/limits.js
const MB = 1024 * 1024;

export const ARTIFACT_MAX_BYTES = {
  tracker: 5 * MB,
  zip: 25 * MB,
  glb: 20 * MB,
  usdz: 20 * MB,
  thumbnail: 2 * MB,
};

export const PROJECT_MAX_BYTES = 50 * MB;

export const ARTIFACT_LABELS = {
  tracker: "Tracker image",
  zip: "Zip model",
  glb: "GLB",
  usdz: "USDZ",
  thumbnail: "Thumbnail",
};

export function formatBytes(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < MB) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / MB).toFixed(bytes >= 10 * MB ? 0 : 1)} MB`;
}

export function assertFileWithinLimit(artifact, byteSize) {
  const max = ARTIFACT_MAX_BYTES[artifact];
  if (!max) {
    return { ok: false, error: `Unknown artifact: ${artifact}` };
  }
  if (byteSize > max) {
    const label = ARTIFACT_LABELS[artifact] || artifact;
    return {
      ok: false,
      error: `${label} is too large (${formatBytes(byteSize)}). Max is ${formatBytes(max)}.`,
      code: "FILE_TOO_LARGE",
      maxBytes: max,
      fileSize: byteSize,
    };
  }
  return { ok: true, maxBytes: max };
}
